// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fire-extinguishers.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fire-extinguishers/fire-extinguishers.js';

mount([g0]);
